import * as Util from "./Util";

export class QuestionSectionQuestion {
  private readonly element: HTMLElement;
  private readonly answer: HTMLElement;
  private readonly indicator: HTMLElement;

  private active: boolean;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.answer = Util.findByBindName("question-section-answer", element) as HTMLElement;
    this.indicator = Util.findByBindName("question-section-symbol-img", element) as HTMLElement;
    this.active = false;

    element.addEventListener("click", this.clickHandler.bind(this));
  }

  private clickHandler(): void {
    this.active = !this.active;
    if (this.active) {
      this.enableDropDown();
    } else {
      this.disableDropDown();
    }
  }

  private enableDropDown(): void {
    this.indicator.classList.add("active");
    this.answer.style.height = this.answer.scrollHeight.toString() + "px";
  }

  private disableDropDown(): void {
    this.indicator.classList.remove("active");
    this.answer.style.height = "0px";
  }
}

export default function bindQuestions(): void {
  const dropDowns = Util.findByBindNameAll("question-section-question");
  dropDowns.forEach((d) => new QuestionSectionQuestion(d as HTMLElement));
}
